const collapsedClass = 'sub-page-cover__search--collapsed'

function addCollapsed(e, el) {
  el.classList.add(collapsedClass)
}

function toggleCollapsed(e, el) {
  el.classList.toggle(collapsedClass, e.target.value.trim() !== '')
}

export default function inputCollapsedAnimation(page) {
  const elements = page.querySelectorAll('[data-collapse-input]')

  elements.forEach(el => {
    const input = el.querySelector('input') || el

    input.addEventListener('focus', e => addCollapsed(e, el))
    input.addEventListener('blur', e => toggleCollapsed(e, el))
  })
}
